export default class PortfolioView extends Backbone.View
  events:
    "click .js-scroll-top"                : "scrollToTheTop"
    "click .js-toggle-availability"       : "toggleFreelanceAvailability"
    "click .js-portfolio-filter"          : "onFilterClick"

  initialize: (options) ->
    super(options)

    @clip = @$el
    that = @

    @$clipsContainer = @$(".clips-container")
    @$publicationsContainer = @$(".filter-by-brands ul")
    @$scrollToTopButton = @$(".js-scroll-top")
    @availableForFreelance = options.available_for_freelance

    @initInfiniteScroll()
    @setupGridLayout()
    @setupCarousel()

    if @filteredPortfolioView()
      @setSelectedPublication()
      @showResetFilterLink()

  setupGridLayout: ->
    @$(".clip").show()
    @$grid = $(".clips-container").colcade({
      columns: ".grid-col",
      items: ".clip"
    })

  setupCarousel: ->
    $ ->
      $(".clip-image-container").each(() ->
        $(this).magnificPopup({
          delegate: ".clip-asset",
          type: 'image',
          tLoading: 'Loading preview...',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1]
          },
          image: {
            tError: '<a href="%url%" target="_blank">The image</a> could not be loaded.',
            titleSrc: 'title'
          }
        })
      )

  filteredPortfolioView: ->
    window.location.href.split("/").slice(-2)[0] == "pub"

  setSelectedPublication: (e) ->
    publication = $("[data-slug='#{window.location.href.split("/").pop().replace("#", "").replace("?preview=true", "")}']")
    if window.location.href.split("?").pop() == "preview=true" then preview = true else preview = false

    @$publicationsContainer.children().addClass("inactive")
    publication.addClass("active").removeClass("inactive")

    url = window.location.href.split("/")[2]
    url += "?preview=true" if preview

  showResetFilterLink: ->
    @$(".js-reset-filters").show()

  initInfiniteScroll: ->
    @nextPage = 2
    @loadingClips = false
    @loadedAllClips = false

    @loadClipsUrl = window.location.pathname + window.location.search
    if @loadClipsUrl.indexOf('?') >= 0
      @loadClipsUrl = "#{@loadClipsUrl}&page="
    else
      @loadClipsUrl = "#{@loadClipsUrl}?page="

    $(window).scroll('scroll', @onScroll).scroll()

  onScroll: (event) =>
    if @loadingClips || @loadedAllClips
      return

    if @nearBottomOfPage()
      @loadingClips = true
      @$('.loading-clips').removeClass("hidden")
      @clipsRequest(@loadClipsUrl)
      @revealScrollToTop()

  clipsRequest: (publicationUrl) =>
    @loadedAllClips = false

    @clipsRequestXhr.abort() if !!@clipsRequestXhr
    url = "#{publicationUrl}#{@nextPage}"

    @clipsRequestXhr = $.ajax({
      url: url,
      type: 'GET',
      dataType: 'json',
      success: @clipsLoadedSuccess
    })

  clipsLoadedSuccess: (data) =>
    @$('.loading-clips').addClass("hidden")
    if !data || data.length == 0
      @loadedAllClips = true
      $(window).unbind('scroll', @onScroll)
    else
      for clipPacket in data
        $clip = $(clipPacket.html)
        $clip.show()
        @$grid.colcade("append", $clip)
      @nextPage++

    @setupCarousel()
    @loadingClips = false

  nearBottomOfPage: ->
    return $(window).scrollTop() > $(document).height() - $(window).height() - 600

  revealScrollToTop: ->
    @$scrollToTopButton.show()

  scrollToTheTop: (e) ->
    e.preventDefault()
    $("html, body").animate({ scrollTop: "0" })
    @$scrollToTopButton.hide()

  toggleFreelanceAvailability: ->
    $.ajax
      url: "portfolio/profile",
      type: "PUT",
      dataType: "json",
      data: {
        user: {
          available_freelance: !@availableForFreelance
        },
        from_portfolio: true
      },
      error: ->
        contently.flash.alert("There was an error updating your availability.")

  onFilterClick: (e) ->
    toggleId = $(e.target).closest("li").data("target")
    $toggleEl = $("#" + toggleId)
    $toggleEl.prop("checked", !$toggleEl.is(":checked"))



// WEBPACK FOOTER //
// ./app/javascript/backbone/portfolio/views/portfolio_view.js.coffee